<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Import Nodes</h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onClose()"
      title="Close"
    ></i>
  </div>

  <div class="modal-body">
    <div class="actionBar d-flex" style="height: 1.6rem">
      <div class="flex-grow-1">
        <input
          class="searchBar float-start"
          type="text"
          placeholder="Search by name"
          [(ngModel)]="filterText"
          (ngModelChange)="applyFilter()"
        />
      </div>
      <!-- <div style="width: 100%; text-align: center" class="pt-3">
            <ng-select appearance="outline" appendTo="body" labelForId="Create a new node group or attach to an existing one" [searchable]="true" formControlName="nodeGroupName" placeholder="Create a new node group or attach to an existing one">
                <ng-option *ngFor="let group of existingNodeGroupsList" [value]="group">{{ group }}</ng-option>
              </ng-select>
        </div> -->
    </div>
    <div>
      <form
        spellcheck="false"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
        style="padding: 6px"
      >
        <div class="listTable flex-grow-1" style="white-space: nowrap">
          <div
            style="
              height: 60vh;
              overflow-y: auto;
              border-bottom: 1px solid #cccccc;
            "
          >
            <table
              class="table table-hover"
              cellspacing="0"
              style="border-collapse: collapse"
            >
              <thead style="text-align: center">
                <tr style="height: 22px" class="synchpc-th">
                  <th
                    style="width: 60px"
                    class="selectAllCheckBox"
                    title="Select All"
                    (change)="onSelectAllCheckBox($event)"
                  >
                    <input type="checkbox" [checked]="isSelectAll" id="" />
                  </th>
                  <th scope="col" resizable>
                    <a
                      style="
                        color: White;
                        text-decoration: none;
                        cursor: default;
                      "
                      >Name</a
                    >
                  </th>
                  <th scope="col">IP</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let node of applyFilter(); let i = index"
                  style="cursor: pointer"
                >
                  <td>
                    {{ i + 1 }}.
                    <input
                      type="checkbox"
                      title="Select Node"
                      class="selectCheckbox"
                      (click)="checkSelectedCheckboxes($event, node.vmNames)"
                      [checked]="multiSelectIndex.includes(node.vmNames)"
                    />
                  </td>
                  <td>{{ node.vmNames }}</td>
                  <td>{{ node.ip }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="width: 100%; text-align: center" class="pt-3">
          <label for=""
            >Note : It is assumed that nodes are already provisioned</label
          >
        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Close
    </button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">
      Submit
    </button>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="attachNode"
  ><p class="pleaseWait">Please wait ...</p></ngx-spinner
>
